import { FC } from 'react';
import { themeColors, themeSizes } from '../../../styles/globalStyleVars';
import { IconCircleCheck } from '@tabler/icons-react';
import { AlertInterface } from '../../../interfaces/AlertInterface';
import { ExpiredAlertItem } from './ExpiredAlertItem';
import { AlertsDrawerEmptyState } from './AlertsDrawerEmptyState';
import { DrawerContent } from '../SharedDrawer';
import { TypographyStyled } from '../../Styled/Typography';
import styled from 'styled-components';
import {
  alertsDrawerContentPadding,
  alertsDrawerScrollbarStyles,
} from './AlertsDrawerScrollStyles';

interface Props {
  showEmptyState: boolean;
  alertsOutages: AlertInterface[];
}

const ExpiredAlertsScrollableContent = styled.div`
  padding: ${alertsDrawerContentPadding};
  border-right: 12px solid transparent;
  ${alertsDrawerScrollbarStyles}
`;

export const AlertsDrawerExpiredContent: FC<Props> = ({
  showEmptyState,
  alertsOutages,
}) => {
  const renderContent = () => {
    if (showEmptyState) {
      return (
        <AlertsDrawerEmptyState
          heading='There are no expired alerts or outages to display.'
          subheading='Only alerts that have expired in the past 30 days are shown here.'
          icon={<IconCircleCheck size={32} color={themeColors.colorGray_5} />}
        />
      );
    }

    return (
      <ExpiredAlertsScrollableContent
        className='alert-item'
        id='alerts-list-wrapper'
      >
        <div style={{ paddingBottom: themeSizes.xl }}>
          <TypographyStyled
            text='These alerts have expired and are shown for reference. If you are
          still affected by one of these issues, please create a ticket.'
            color={themeColors.colorGray_8}
            style={{ marginTop: themeSizes.sm }}
          />
        </div>
        {alertsOutages.map((alert: AlertInterface, index: number) => (
          <ExpiredAlertItem alert={alert} showSummaryByDefault key={index} />
        ))}
      </ExpiredAlertsScrollableContent>
    );
  };

  return (
    <DrawerContent style={{ flex: 1, minHeight: 0, padding: 0 }}>
      {renderContent()}
    </DrawerContent>
  );
};
